module.exports = __webpack_public_path__ + "static/media/rightOutlined.b0f30a72.svg";